import { useAuthStore } from '@sentinel/web-core';
import { SpaceSwitch } from '../nav/SpaceSwitch';
import { Brand } from './Brand';
import { MissionSelector } from './MissionSelector';
import { NotificationBell } from './NotificationBell';
import { useTopbarSlot } from './TopbarActions';
import { UserCard } from './user/UserCard';

/** Header proposal 11: mark and level, the active operation with its timer and the actions of
 *  the open page; on the right the PCA · Segreteria switch, the bell and the user card.
 *  Connection and services are in the status bar; organization, theme and language in the
 *  user card. */
export function Topbar() {
  const me = useAuthStore((s) => s.me);
  const setSlot = useTopbarSlot((s) => s.setNode);
  const inOrganization = me?.organization !== null && me?.organization !== undefined;

  return (
    <header className="topbar">
      <Brand />
      {inOrganization ? (
        <>
          <span className="tb-sep" aria-hidden="true" />
          <MissionSelector />
          <div className="tb-acts" ref={setSlot} />
        </>
      ) : null}
      <span className="tb-grow" />
      {inOrganization ? <SpaceSwitch /> : null}
      <div className="tools">
        <NotificationBell enabled={inOrganization} />
        <UserCard />
      </div>
    </header>
  );
}
